<template>
    <div
        ref="container"
        class="poll-container relative w-full overflow-y-scroll md:overflow-auto md:border-t"
    >
        <div class="max-md:container py-4 md:pt-6 md:pb-3 md:px-6">
            <span class="text-lg font-medium md:hidden">{{ t('Survey') }}</span>
            <span class="text-lg font-medium hidden md:inline">{{ t('Add a survey') }}</span>
        </div>
        <div
            v-for="(option, index) in pollOptions"
            :key="index"
            class="max-md:container md:px-6 py-1 border-b w-full inline-flex items-center md:border-none md:py-2"
        >
            <input
                v-model="pollOptions[index]"
                type="text"
                :placeholder="t('Type option {index}…', { index: index + 1 })"
                @input="updateOptions"
            />
            <div
                v-if="pollOptions.length > 2"
                class="absolute py-2 right-7 leading-4 items-center flex"
            >
                <Btn
                    variant="tonal"
                    class="mr-2 text-slate-400"
                    content-color="slate-600"
                    icon="trash"
                    size="xxs"
                    color-on-touch
                    @click.prevent.stop="removeOption(index)"
                />
            </div>
            <i
                v-if="pollOptions.length > 2"
                class="hidden icon icon-trash h-5 w-5 mx-0 my-2 cursor-pointer text-slate-400 hover:text-slate-600"
                @click.prevent.stop="removeOption(index)"
            />
        </div>
        <div class="px-6 py-4 items-center md:inline-flex md:mb-2">
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <BtnCta
                variant="secondary"
                class="w-full mb-4 md:mb-0 md:mr-8 md:w-auto"
                :label="t('addFurtherOption')"
                :disabled="pollOptions.length >= maxOptions"
                @click.prevent.stop="addOption"
            />
            <InputCheckbox
                :checked="multiVote"
                @change="updateMultiVote"
            >
                {{ t('allowMultipleChoice') }}
            </InputCheckbox>
        </div>
    </div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'PostCreatePoll',
    components: {
        InputCheckbox,
    },
    props: {
        multiVote: {
            type: Boolean,
            default: false,
        },
        maxOptions: {
            type: Number,
            default: 10,
        },
    },
    emits: ['update-multi-vote', 'update-poll-options'],
    setup() {
        const { t } = useTranslation('post');
        return { t };
    },
    data() {
        return {
            pollOptions: ['', '', ''],
        };
    },
    methods: {
        addOption() {
            this.pollOptions.push('');
            this.scrollToBottom();
        },
        removeOption(index) {
            this.pollOptions.splice(index, 1);
        },
        scrollToBottom() {
            setTimeout(() => {
                const scrollingElement = this.$refs.container;
                scrollingElement.scrollTop = scrollingElement.scrollHeight;
            }, 500);
        },
        updateMultiVote() {
            this.$emit('update-multi-vote', !this.multiVote);
        },
        updateOptions() {
            this.$emit('update-poll-options', this.pollOptions);
        },
    },
};
</script>

<style lang="scss" scoped>
.poll-container {
    height: calc(100% - 14.5rem);
}
.right-7 {
    right: 1.75rem;
}
input[type='text'] {
    @apply bg-white border-none pl-0 pr-8;
}
@screen md {
    input[type='text'] {
        @apply bg-slate-50 py-1 pl-2 rounded border-2 border-solid border-slate-100;

        &:hover {
            @apply border-blue-300;
        }

        &:focus,
        &:active {
            @apply border-blue-600;
        }
    }
}
</style>
